import React from "react";
import { FaQuestion } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";

const HoaOffer = () => {
    return (
        <div className="pt-20 h-[110vh] sm:h-[110vh] md:h-[100vh] lg:h-[55vh] xl:h-[50vh] 2xl:h-[95vh]" id="#hoa-offer">
            <div className="w-[85%] mx-auto">
                <div className="flex justify-center items-center flex-col leading-none text-center">
                    <h1 className="text-blue-800 text-[32px] sm:text-[32px] md:text-[40px] lg:text-[48px]">
                        What do we offer?
                    </h1>
                </div>

                <div className="pt-10">
                    <div className="h-[147px] rounded-[10px] bg-gradient-to-b from-blue-800 via-blue-800/27 to-blue-800/0 relative">
                        <div className="absolute rounded-[5px] left-5 right-5 mx-auto top-20 flex justify-between bg-white shadow-[5px_6px_10px_6px_rgba(0,0,0,0.1)] flex-col lg:flex-row">
                            <div className="flex items-start flex-col gap-[19px] px-5 w-full lg:w-1/2 py-5 lg:py-[30px] pb-2.5 lg:pb-[30px]">
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Monthly HOA payment</p>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Email Communication</p>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Maintenance Service Request</p>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Vendor Management</p>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Amenities Booking</p>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Data Security & Privacy</p>
                                </div>
                            </div>

                            <div className="flex items-start flex-col gap-[19px] px-5 w-full lg:w-1/2 py-2.5 lg:py-[30px] pb-5 lg:pb-[30px]">
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Notification Capability</p>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Reporting</p>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Budget planning</p>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Violations Tracking</p>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <FaCheckCircle className="text-blue-800 text-base sm:text-base md:text-xl lg:text-[25px]" />
                                    <p className="text-base sm:text-base md:text-xl lg:text-[25px] m-0">Email and Phone support</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HoaOffer;